import { Pipe, PipeTransform, Injectable } from '@angular/core';
import {SergasDeviceValuelistService} from "./SergasDeviceValuelist.service";

@Pipe({name: 'SergasDevice'})
export class SergasDevicePipe implements PipeTransform {

  constructor(private valuelist: SergasDeviceValuelistService) {
  }

  transform(value: string, field: string): string {
    let list = this.valuelist.getValuelist();
    return list[value] && list[value][field] || "";
  }
}
